import { Avatar, type AvatarSize } from "@/components/ui";
import { cx } from "@/lib/cx";

type Person = { id: string; name: string; image: string | null; kind: "human" | "bot" };

/** Up to `max` overlapping avatars; the rest as "+N". Names are in the accessible label. */
export function AvatarStack({
  people,
  max = 2,
  size = "sm",
  className,
}: {
  people: Person[];
  max?: number;
  size?: AvatarSize;
  className?: string;
}) {
  if (people.length === 0) return null;
  const shown = people.slice(0, max);
  const rest = people.length - shown.length;
  const names = people.map((p) => p.name).join(", ");
  return (
    <span role="img" aria-label={names} title={names} className={cx("inline-flex shrink-0 items-center", className)}>
      {shown.map((p, i) => (
        <Avatar
          key={p.id}
          name={p.name}
          seed={p.id}
          src={p.image}
          bot={p.kind === "bot"}
          size={size}
          labelled={false}
          className={cx(i > 0 && "-ml-1.5 ring-2 ring-canvas")}
        />
      ))}
      {rest > 0 ? <span className="ml-1 text-2xs text-fg-subtle tnum">+{rest}</span> : null}
    </span>
  );
}
